<template>
  <v-dialog v-model="localDialog" content-class="taxConfigDialog" persistent width="90%">
    <v-card>
      <v-card-title class="headline">
        <h1>Taxas da Campanha</h1>
        <v-btn class="close-modal" @click="closeModal">
          <i class="fal fa-times"></i>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <v-layout column>
          <div class="box-main" style="padding-bottom: 0px !important; ">
            <TaxForm ref="taxesForm" :campaignMode="true" :initialAsaas="asaas" :initialPagarme="pagarme"
              :initialItau="itau" />
          </div>
        </v-layout>
      </v-card-text>

      <v-card-actions class="pa-0">
        <div class="footer-modal-atividades">
          <v-btn flat round color="white" class="btn btn-default px-5" large @click="closeModal">Cancelar</v-btn>
          <v-btn flat round color="white" class="btn btn-primary px-5" large @click="handleSubmit">Salvar</v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import PaymentMethodProvider from "@/scripts/models/enums/paymentMethodProvider.enum";
import TaxService from "@/scripts/services/tax.service";
import TaxForm from "@/components/TaxForm.vue";
import Tax, { taxHasCustom, buildSparseTaxPayload } from "@/scripts/models/tax.model.js";

export default {
  components: {
    TaxForm,
  },
  props: {
    value: { type: Boolean, default: false } // v-model
  },
  data() {
    return {
      asaas: new Tax(this.$attrs.campaignId, PaymentMethodProvider.Asaas, false),
      pagarme: new Tax(this.$attrs.campaignId, PaymentMethodProvider.PagarMe, false),
      itau: new Tax(this.$attrs.campaignId, PaymentMethodProvider.Itau, false),
      taxService: new TaxService(),
      localDialog: this.value,
    };
  },
  watch: {
    value(val) {
      this.localDialog = val;
    },
    localDialog(val) {
      this.$emit("input", val);
    }
  },
  created() {
    this.loadTaxes();
  },
  methods: {
    // Carrega o padrao da plataforma e os overrides da campanha e faz o merge:
    // o default e a base; onde houver taxa custom da campanha ela sobrepoe.
    async loadTaxes() {
      const [defaults, campaign] = await Promise.all([
        this.taxService.getDefault(),
        this.taxService.getByCampaign(this.$attrs.campaignId),
      ]);

      this.asaas = this.buildMerged(PaymentMethodProvider.Asaas, defaults && defaults.asaas, campaign && campaign.asaas);
      this.pagarme = this.buildMerged(PaymentMethodProvider.PagarMe, defaults && defaults.pagarMe, campaign && campaign.pagarMe);
      this.itau = this.buildMerged(PaymentMethodProvider.Itau, defaults && defaults.itau, campaign && campaign.itau, true);
    },
    buildMerged(provider, defaultTax, campaignTax, isItau = false) {
      const tax = new Tax(this.$attrs.campaignId, provider, false);
      tax.loadFromDefault(defaultTax);
      tax.mergeCampaign(campaignTax);
      if (isItau) {
        // Itau nao trabalha com parcelamento de cartao.
        tax.parcelamentsD2 = [];
        tax.parcelamentsD30 = [];
      }
      return tax;
    },
    async handleSubmit() {
      const formData = this.$refs.taxesForm.getFormData();
      const { asaas, pagarme, itau } = formData;

      // Salva apenas os provedores que possuem alguma taxa personalizada
      // (os demais continuam herdando o default da plataforma).
      const request = [asaas, pagarme, itau]
        .filter((tax) => taxHasCustom(tax))
        .map((tax) => this.taxService.save(buildSparseTaxPayload(tax)));

      if (request.length > 0) {
        await Promise.all(request);
        await this.loadTaxes();
      }
    },
    closeModal() {
      this.localDialog = false;
    },
  }
};
</script>